"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function assert(expr, msg) {
  if (!expr) {
    throw new Error(typeof msg === 'string' ? msg : msg());
  }
}

exports.assert = assert;

function assertShapesMatch(shapeA, shapeB) {
  var errorMessagePrefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  assert(arraysEqual(shapeA, shapeB), errorMessagePrefix + " Shapes ".concat(shapeA, " and ").concat(shapeB, " must match"));
}

exports.assertShapesMatch = assertShapesMatch;

function arraysEqual(n1, n2) {
  if (n1.length !== n2.length) {
    return false;
  }

  for (var i = 0; i < n1.length; i++) {
    if (n1[i] !== n2[i]) {
      return false;
    }
  }

  return true;
}

exports.arraysEqual = arraysEqual;
exports.DECIMAL_PLACES_TO_CHECK = 4;